export default "__VITE_ASSET__BkrL9Wxb__"